var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bpb-form-stepper-button-next',{staticClass:"questionnaire__button",attrs:{"required-fields":_vm.requiredFields}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }